export const transform = data => {
  const { merchant_id, branch_id, ...rest } = data;

  const normalizedBranchId = Array.isArray(branch_id)
    ? branch_id.filter(Boolean)
    : branch_id && branch_id !== ''
      ? [branch_id]
      : [];

  return {
    ...rest,
    branch_id: normalizedBranchId,
  };
};
